/*
 * Candidate Leaves Tab Messages
 *
 * This contains all the text for the Candidate Leaves Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateLeavesTab';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Leaves',
  },
  dateColumnLabel: {
    id: `${scope}.dateColumnLabel`,
    defaultMessage: 'Date Range',
  },
  typeColumnLabel: {
    id: `${scope}.typeColumnLabel`,
    defaultMessage: 'Unavailability Type',
  },
  deleteLeaveConfirmMessage: {
    id: `${scope}.deleteLeaveConfirmMessage`,
    defaultMessage: 'Are you sure you want to delete this leave?',
  },
  deleteLeaveTooltip: {
    id: `${scope}.deleteLeaveTooltip`,
    defaultMessage: 'Delete',
  },
});
